import { Close as CloseIcon } from '@mui/icons-material';
import Button from '@mui/material/Button';
import type { FunctionComponent } from 'react';
import { Fragment, useContext, useState } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { ResetConfigurationModal } from './ResetConfigurationModal';

type ResetConfigurationButtonProps = {
    readonly disabled: boolean;
    readonly onResetConfiguration: () => void;
};

export const ResetConfigurationButton: FunctionComponent<ResetConfigurationButtonProps> = ({
    disabled,
    onResetConfiguration,
}) => {
    const { translate } = useContext(ApplicationContext);
    const [openDialog, setOpenDialog] = useState(false);

    return (
        <Fragment>
            <ResetConfigurationModal
                closeModal={() => setOpenDialog(false)}
                content={translate('pages.user-profile.profile-visibility.drawer.reset-configuration.all.content')}
                open={openDialog}
                title={translate('pages.user-profile.profile-visibility.drawer.reset-configuration.all.title')}
                onReset={onResetConfiguration}
            />
            <Button
                aria-label="Reset Profile Visibility Settings"
                disabled={disabled}
                fullWidth={true}
                startIcon={<CloseIcon />}
                sx={{
                    '&:hover': {
                        backgroundColor: 'secondary.main',
                    },
                    backgroundColor: 'secondary.main',
                }}
                type="button"
                variant="contained"
                onClick={() => setOpenDialog(true)}
            >
                {translate('pages.user-profile.profile-visibility.drawer.reset-button')}
            </Button>
        </Fragment>
    );
};
